module.exports = __webpack_public_path__ + "static/media/logo-white.63c53e8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/logo-white.png
// module id = 1166
// module chunks = 0